import {Configuration, UiApiAuthApi, UiApiUsersApi} from "../../api_client";
import {BasePathUrl} from "../../appsettings";
import {authStore} from "../../features/auth/data";
import {getAllPermissions} from "../../hooks/useUserPermissions";
import store from "../../redux/store";
import {Events, type BroadcastEvent} from "./EventsBroadcastChannel.constants";
import type {EventHandlersMap} from "./EventsBroadcastChannel.types";
import {t} from "i18next";

/**
 * Перечитывает claims/user после смены cookie-сессии (impersonate / end).
 * Полная browser-навигация на Impersonate GET дополнительно обновляет OIDC-тикеты;
 * этот handler нужен для flushDeferred / soft-refresh на вкладке.
 */
const refreshAuthSession = async (): Promise<void> => {
  const config = new Configuration({basePath: BasePathUrl});
  const authApi = new UiApiAuthApi(config);
  const usersApi = new UiApiUsersApi(config);

  const userClaims = await authApi.uiApiAuthUserPermissionsGet();
  store.dispatch(authStore.actions.setUserClaims(userClaims));

  const moduleAccess = getAllPermissions(userClaims).moduleAccess;
  store.dispatch(authStore.actions.setIsAuth(moduleAccess));

  if (!moduleAccess) {
    store.dispatch(authStore.actions.setError({
      code: "USER_PERMISSION_ERR",
      message: t("messages.userAccessIsNotAllowed")
    }));
  } else {
    store.dispatch(authStore.actions.setError(undefined));
  }

  const user = await usersApi.uiApiUsersCurrentGet();
  store.dispatch(authStore.actions.setUser(user));
  store.dispatch(authStore.actions.resetNavigationLoading());
};

/** Локальные обработчики вкладки-отправителя (вызываются из send()). */
export const localHandlers: EventHandlersMap<BroadcastEvent> = {
  [Events.impersonate]: refreshAuthSession,
  [Events.impersonateEnd]: refreshAuthSession,
  [Events.logout]: () => {
    store.dispatch(authStore.actions.clearAuthData());
  }
};
